// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Registration_tabs__3wQjE","title":"Registration_title__1kTxe","main":"Registration_main__2VSVm","text":"Registration_text__XUeh-"};